import React, { useEffect, useState } from "react";
import "../assets/css/style.css";
import {
  agecategorychampionslist,
  agecategoryindchampionslist,
  athleticstartresultlist,
  athletictoureventstartexceptheatlist,
  athletictourordereventslist,
  eventplayerentrylist,
  externaltourdetails,
  exteventphotoslist,
  funderdetail,
  highlightslist,
  othereventdetails,
  photoslist,
  poollisttour,
  tourcategoryfixtures,
  tourcategorylist,
  tourdetails,
  tourpointslist,
  tourteamplayerlist,
  tourteamslist,
} from "../services/site";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional Theme applied to the Data Grid
import { Accordion, Row, Tab, Tabs } from "react-bootstrap";
import dotracking from "./trackinglogs";
import Carousel, { Modal, ModalGateway } from "react-images";
import { grpschdetail } from "../services/grpsch";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";

export const Tournament = () => {
  const { fun, id } = useParams();
  const navigate = useNavigate();
  const [tactive, setTActive] = useState("1");
  const [sports, setSports] = useState("");

  const [mtype, setMtype] = useState("");

  const [agecat, setAgeCat] = useState([]);
  const [agecatdef, setAgeCatDef] = useState("");

  const [tdet, setTDet] = useState("");

  const [rowData, setRowData] = useState([]);

  const [lmatch, setLMatch] = useState([]);
  const [qmatch, setQMatch] = useState([]);
  const [smatch, setSMatch] = useState([]);
  const [fmatch, setFMatch] = useState([]);

  const [lboard, setLBoard] = useState([]);

  const [tlist, setTList] = useState([]);

  const [plist, setPList] = useState([]);
  const [poollist, setPoolList] = useState([]);

  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [photolist, setPhotoLink] = useState([]);
  const [ephotolist, setEPhotoLink] = useState([]);

  const [hlist, setHList] = useState([]);
  const [high, setHigh] = useState("");

  function tabclick(tid, ttab) {
    if (urllink == "tournamentdetails") {
      dotracking(3, fun, ttab, id, fun);
    } else if (urllink == "fundertournamentdetails") {
      dotracking(2, fun, ttab, id, fun);
    }
    setTActive(tid);
    if (tid == 2) {
      subtabclick(agecatdef);
    } else if (tid == 3) {
      ledtabclick(agecatdef);
    } else if (tid == 4) {
      teamtabclick(agecatdef);
    } else if (tid == 5) {
      pooltabclick(agecatdef);
    } else if (tid == 6) {
      galtabclick(id);
    }
  }

  function etabclick(tid, ttab) {
    if (urllink == "tournamentdetails") {
      dotracking(3, fun, ttab, id, fun);
    } else if (urllink == "eventdetails") {
      dotracking(2, fun, ttab, id, fun);
    }
    setTActive(tid);
  }
  const [fundname, setFundName] = useState("");
  const [funddesc, setFundDesc] = useState("");
  const [fundmail, setFundMail] = useState("");
  const [fundmob, setFundMob] = useState("");
  const [fundaddr, setFundAddr] = useState("");
  const [logofile, setLogoFile] = useState("");
  const [urllink, setUrlLink] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
    const url = window.location.href;
    const data = url.split("/#/");
    const link = data[1].split("/");
    setUrlLink(link[0]);
    if (link[0] === "tournamentdetails") {
     
      grpschdetail(fun).then((response) => {
        if (response.status === true) {
          var sl = response.data.funders_details.group_of_school_name.toLowerCase();
          sl = sl.trim();
          sl = sl.replace(/ /g, "_");
          window.location.replace('https://pathwayz.sportzvillage.com/groups/#/'+sl+"/" + fun);
  
          setFundName(response.data.funders_details.group_of_school_name);
          setFundDesc(
            response.data.funders_details.group_of_school_description
          );
          if (response.data.funders_details.email !== null) {
            setFundMail(response.data.funders_details.email);
          }
          if (response.data.funders_details.mobile !== null) {
            setFundMob(response.data.funders_details.mobile);
          }
          if (response.data.funders_details.address !== null) {
            setFundAddr(response.data.funders_details.address);
          }

          if (response.data.funders_details.logo !== null) {
            setLogoFile(
              response.data.logo_path + response.data.funders_details.logo
            );
          }
        }
      });
    } else {
     
      funderdetail(fun).then((response) => {
        if (response.status === true) {
          var sl = response.data.funders_details.funder_name.toLowerCase();
        sl = sl.trim();
        sl = sl.replace(/ /g, "_");
        window.location.replace('https://pathwayz.sportzvillage.com/funder/#/'+sl+"/" + fun);
          setFundName(response.data.funders_details.funder_name);
          setFundDesc(response.data.funders_details.funder_description);
          if (response.data.funders_details.email !== null) {
            setFundMail(response.data.funders_details.email);
          }
          if (response.data.funders_details.mobile !== null) {
            setFundMob(response.data.funders_details.mobile);
          }
          if (response.data.funders_details.address !== null) {
            setFundAddr(response.data.funders_details.address);
          }

          if (response.data.funders_details.logo !== null) {
            setLogoFile(
              response.data.logo_path + response.data.funders_details.logo
            );
          }
        }
      });
    }

    if (
      link[0] === "fundertournamentdetails" ||
      link[0] === "tournamentdetails" ||
      link[0] === "externaltournamentdetails"
    ) {
      if (link[0] === "externaltournamentdetails") {
        externaltourdetails(id).then((res) => {
          if (res.status === true) {
            if (res.data.tournament !== null) {
              setTDet(res.data.tournament);
              setSports(res.data.tournament.sports_type);
              setMtype(res.data.tournament.meet_type);
            }
          }
        });
        exteventphotoslist(id, 1).then((response) => {
          if (response.status === true) {
            if (response.data.tournamentlist.length !== 0) {
              let arr1 = [];
              for (let i = 0; i < response.data.tournamentlist.length; i++) {
                arr1.push({
                  id: response.data.tournamentlist[i].id,
                  src:
                    response.data.tournamentimage_path +
                    response.data.tournamentlist[i].imagename,
                  width: 1,
                  height: 1,
                });
              }
              setEPhotoLink(arr1);
            }
          }
        });
      } else {
        tourdetails(id).then((res) => {
          if (res.status === true) {
            if (res.data.tournament !== null) {
              let arr = [];
              setTDet(res.data.tournament);
              setSports(res.data.tournament.sports_type);
              setMtype(res.data.tournament.meet_type);
              if (
                res.data.tournament.sports_type.toUpperCase() === "ATHLETICS"
              ) {
                if (res.data.age_category.length !== 0) {
                  for (let i = 0; i < res.data.age_category.length; i++) {
                    arr.push({
                      id: res.data.age_category[i].id,
                      category_name: res.data.age_category[i].age_categories,
                      category_gender: res.data.age_category[i].gender,
                    });
                  }
                  setAgeCat(arr);
                  setAgeCatDef(arr[0].id);
                }
              } else {
                const temp = new FormData();
                temp.append("tournament_id", id);
                tourcategorylist(temp).then((response) => {
                  if (response.status === true) {
                    let arr = [];
                    if (response.data.category_list.length !== 0) {
                      for (
                        let i = 0;
                        i < response.data.category_list.length;
                        i++
                      ) {
                        arr.push({
                          id: response.data.category_list[i].id,
                          category_name:
                            response.data.category_list[i].category_name,
                          category_gender:
                            response.data.category_list[i].category_gender,
                        });
                      }
                      setAgeCat(arr);
                      setAgeCatDef(arr[0].id);
                    }
                  }
                });
              }
            }
          }
        });
        athletictourordereventslist(id).then((response) => {
          if (response.status === true) {
            setRowData(response.data);
          }
        });

        photoslist(id).then((response) => {
          if (response.status === true) {
            if (response.data.tournamentlist.length !== 0) {
              let arr1 = [];
              for (let i = 0; i < response.data.tournamentlist.length; i++) {
                arr1.push({
                  id: response.data.tournamentlist[i].id,
                  src:
                    response.data.tournamentimage_path +
                    response.data.tournamentlist[i].imagename,
                  width: 1,
                  height: 1,
                });
              }
              setPhotoLink(arr1);
            }
          }
        });
      }

      highlightslist(id).then((response) => {
        if (response.status === true) {
          setHList(response.data);

          const fdata = response.data.filter((item) => {
            return item.highlights_type == 2;
          });
          if (fdata !== undefined) {
            if (fdata.length !== 0) {
              setHigh(fdata[0].highlight_links);
            }
          }
        }
      });
    } else if (link[0] === "fundereventdetails" || link[0] === "eventdetails") {
      othereventdetails(id).then((response) => {
        if (response.status === true) {
          setTDet(response.data.events[0]);
        }
      });
      exteventphotoslist(id, 2).then((response) => {
        if (response.status === true) {
          if (response.data.tournamentlist.length !== 0) {
            let arr1 = [];
            for (let i = 0; i < response.data.tournamentlist.length; i++) {
              arr1.push({
                id: response.data.tournamentlist[i].id,
                src:
                  response.data.tournamentimage_path +
                  response.data.tournamentlist[i].imagename,
                width: 1,
                height: 1,
              });
            }
            setEPhotoLink(arr1);
          }
        }
      });
      eventplayerentrylist(id).then((response) => {
        if (response.status === true) {
          setPList(response.data);
        }
      });
    }
  }, []);

  const columnDefs = [
    {
      headerName: "Action",
      width: 120,
      field: "events_order_id",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => listdet(params.value)}
              title="See Results"
              className="btn-sm btn-success me-2"
            >
              See Results
              {/* <i className="fa fa-list fa-lg"></i> */}
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Heats/Finals",
      field: "heat_or_final",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Category",
      field: "age_categories",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Events",
      field: "events",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Date",
      field: "event_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Time",
      field: "time",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Gender",
      field: "gender",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnODefs = [
    {
      headerName: "Place",
      width: 100,
      field: "place",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Time/Distance",
      width: 150,
      field: "time_distance",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Full Name",
      width: 150,
      field: "first_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "BIB No",
      width: 100,
      field: "bib_no",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "School",
      width: 200,
      field: "school_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "DOB",
      width: 120,
      field: "date_of_birth",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null && params.value !== "") {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Class",
      width: 100,
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Gender",
      width: 100,
      field: "gender",
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
    },
  ];
  const [catname, setCatName] = useState("");
  const [listtype, setListType] = useState("");
  const [filterProduct, setFilterProduct] = useState([]);
  const [sshow, setSShow] = useState(false);

  function handlestoryclose() {
    setSShow(false);
    setCatName("");
    setListType("");
    setFilterProduct([]);
  }

  function listdet(oid) {
    setSShow(true);

    athletictourordereventslist(id).then((res) => {
      if (res.status === true) {
        const odata = res.data.find(
          (item) => item.events_order_id === parseInt(oid)
        );
        if (odata !== undefined) {
          setCatName(
            "Age Category - " +
              odata.age_categories +
              ", Events - " +
              odata.events
          );
          setListType(odata.heat_or_final);

          const temp1 = new FormData();
          temp1.append("tournament_meet_id", id);
          temp1.append("age_category_id", odata.age_category_id);
          temp1.append("event_id", odata.event_id);
          temp1.append("heats_finals", odata.heat_or_final);
          athleticstartresultlist(temp1).then((res1) => {
            if (res1.status === true) {
              setFilterProduct(res1.data.results_info);
            }
          });
        }
      }
    });
  }

  function errorhandle(ev) {
    ev.target.src = require("../assets/img/logo-pathway.png");
    ev.target.onerror = null;
  }

  function subtabclick(sid) {
    tourcategoryfixtures(id, sid).then((response) => {
      if (response.status === true) {
        setLMatch(response.data.league_fixtures);
        setQMatch(response.data.q_final_fixtures);
        setSMatch(response.data.s_final_fixtures);
        setFMatch(response.data.final_fixtures);
      }
    });
  }

  function ledtabclick(sid) {
    if (sid !== "") {
      setLBoard([]);
      poollisttour(id, sid).then((response) => {
        if (response.status === true) {
          if (response.data.pool.length !== 0) {
            let arr = [];
            for (let i = 0; i < response.data.pool.length; i++) {
              arr.push({
                pool_id: response.data.pool[i].meet_pool_id,
                pool_name: response.data.pool[i].pool_name,
                pool_points: [],
              });
            }
            setLBoard(arr);
            if (arr.length !== 0) {
              for (let i = 0; i < arr.length; i++) {
                tourpointslist(id, sid, arr[i].pool_id).then((res) => {
                  if (res.status === true) {
                    arr[i].pool_points = res.data;
                    setLBoard([...arr]);
                  }
                });
              }
            }
          }
        }
      });
    }
  }

  function teamtabclick(sid) {
    if (sports.toUpperCase() === "ATHLETICS") {
      playertabclick(sid);
    } else {
      if (sid !== "") {
        tourteamslist(id, sid).then((response) => {
          if (response.status === true) {
            setTList(response.data);
          }
        });
      }
    }
  }

  const [chamlist, setChamList] = useState([]);

  function playertabclick(pid) {
    setPList([]);
    if (sports.toUpperCase() === "ATHLETICS") {
      // if (mtype === "Inter School Tournament") {
      // athleticsintertourentrylist(id).then((response) => {
      //   if (response.status === true) {
      //     setPList(response.data.inter_school_entries);
      //   }
      // });

      const temp = new FormData();
      if (urllink === "tournamentdetails") {
        temp.append("tournament_id", id);
        temp.append("funder_or_group_id", fun);
        temp.append("funder_or_group", 2);
      } else if (urllink === "fundertournamentdetails") {
        temp.append("tournament_id", id);
        temp.append("funder_or_group_id", fun);
        temp.append("funder_or_group", 1);
      }

      agecategorychampionslist(temp).then((response) => {
        if (response.status === true) {
          setChamList(response.data.overall_champions_my_school);
        }
      });

      const temp1 = new FormData();

      if (urllink === "tournamentdetails") {
        temp1.append("tournament_id", id);
        temp1.append("age_category_name", pid);
        temp1.append("funder_or_group_id", fun);
        temp1.append("funder_or_group", 2);
      } else if (urllink === "fundertournamentdetails") {
        temp1.append("tournament_id", id);
        temp1.append("age_category_name", pid);
        temp1.append("funder_or_group_id", fun);
        temp1.append("funder_or_group", 1);
      }

      agecategoryindchampionslist(temp1).then((response) => {
        if (response.status === true) {
          // setPList(response.data.individual_champions);
          const firstThreeItems = response.data.individual_champions.slice(
            0,
            3
          );
          setPList(firstThreeItems);
        }
      });
      // } else if (mtype === "Intra School Tournament") {
      //   athleticsintratourentrylist(id).then((response) => {
      //     if (response.status === true) {
      //       setPList(response.data.individual_entries);
      //     }
      //   });
      // }
    } else {
      tourteamplayerlist(id, pid).then((response) => {
        if (response.status === true) {
          setPList(response.data);
        }
      });
    }
  }

  function pooltabclick(pid) {
    poollisttour(id, pid).then((response) => {
      if (response.status === true) {
        setPoolList(response.data.pool);
      }
    });
  }

  const [shareUrl, setShare] = useState("");
  const [show, setShow] = useState(false);

  function handleshow(timg) {
    setShare(timg);
    setShow(true);
    if (urllink == "tournamentdetails") {
      dotracking(3, fun, "Gallery", id, timg);
    } else if (urllink == "fundertournamentdetails") {
      dotracking(2, fun, "Gallery", id, timg);
    }
  }
  const handleclose = () => {
    setShow(false);
  };

  const [pplist, setPPList] = useState([]);

  function openPLightbox(index, ilist) {
    setCurrentImage(index);
    if (ilist.length !== 0) {
      setPPList(ilist);
    }

    setViewerIsOpen(true);
  }

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };
  function galtabclick(pid) {}
  function backlist() {
    if (urllink == "tournamentdetails") {
      dotracking(3, fun, "Home", id, fun);
    } else if (urllink == "fundertournamentdetails") {
      dotracking(2, fun, "Home", id, fun);
    }
    navigate(-1);
  }

  return (
    <>
      <div className="vs-menu-wrapper">
        <div className="vs-menu-area text-center">
          <div className="mobile-logo">
            <a onClick={backlist}>
              <img
                src={logofile}
                alt="Marino"
                onError={(e) => errorhandle(e)}
              />
            </a>
          </div>
        </div>
      </div>
      <header className="vs-header header-layout5">
        <div className="header-top">
          <div className="vs-container4"></div>
        </div>
        <div className="sticky-wrapper">
          <div className="sticky-active">
            <div className="vs-container2">
              <div className="row align-items-center justify-content-center">
                <div className="col-md-3 col-sm-5 align-self-stretch">
                  <div className="vs-logo style2">
                    <a onClick={backlist}>
                      <img
                        src={logofile}
                        alt="logo"
                        onError={(e) => errorhandle(e)}
                      />
                    </a>
                    <a className="sticky-logo" onClick={backlist}>
                      <img
                        src={logofile}
                        alt="logo"
                        onError={(e) => errorhandle(e)}
                      />
                    </a>
                  </div>
                </div>
                <div className="col-md-6 col-sm-2 mx-0 ">
                  <div className="row gx-50 align-items-center d-none d-md-block">
                    <div className="col d-flex align-items-center justify-content-center">
                      <nav className="main-menu">
                        <ul>
                          <li className="menu-item-has-children">{fundname}</li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 col-sm-5 text-end">
                  <img
                    src={require("../assets/img/logo_sv.png")}
                    alt=""
                    className="sponsorlogo"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div className="breadcumb-wrapper">
        <div className="blog-card__content_bottom float-end me-3">
          {urllink === "tournamentdetails" && (
            <a className="btn btn-danger" onClick={backlist}>
              Check School Webpage
            </a>
          )}
          {urllink !== "tournamentdetails" && (
            <a className="btn btn-danger" onClick={backlist}>
              Checkout Webpage
            </a>
          )}
          {moment(moment(new Date()).format("YYYY-MM-DD")).isBetween(
            tdet.start_date,
            tdet.end_date,
            null,
            "[]"
          ) && (
            // moment(new Date()).format("yyyy-MM-dd") >= tdet.start_date
            // moment(new Date()).format("yyyy-MM-dd") <=
            // tdet.end_date &&
            <div className="text-center mt-2">
              {high !== "" && (
                <a className="btnscreen" href={high} target="_blank">
                  Watch Live Streaming<span className="live-icon"></span>
                </a>
              )}
            </div>
          )}
        </div>
        <div className="tcontainer">
          {(urllink == "tournamentdetails" ||
            urllink == "fundertournamentdetails" ||
            urllink == "externaltournamentdetails") && (
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">{tdet.meet_name}</h1>
              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <a>Home</a>
                  </li>
                  <li>Tournament</li>
                </ul>
              </div>
            </div>
          )}
          {(urllink == "fundereventdetails" || urllink == "eventdetails") && (
            <div className="breadcumb-content">
              <h1 className="breadcumb-title">{tdet.event_name}</h1>
              <div className="breadcumb-menu-wrap">
                <ul className="breadcumb-menu">
                  <li>
                    <a>Home</a>
                  </li>
                  <li>Event</li>
                </ul>
              </div>
            </div>
          )}
        </div>
      </div>
      <section className="bg-smoke space-top space-extra-bottom">
        <div className="col tcontainer">
          {(urllink == "tournamentdetails" ||
            urllink == "fundertournamentdetails" ||
            urllink == "externaltournamentdetails") && (
            <div className="tab_container">
              <input
                id="tab1"
                type="radio"
                name="tabs"
                checked={tactive == 1 ? true : false}
              />
              <label
                htmlFor="tab1"
                onClick={() => tabclick(1, "Tournament Info")}
              >
                <span>Tournament Info</span>
              </label>
              <input
                id="tab2"
                type="radio"
                name="tabs"
                checked={tactive == 2 ? true : false}
              />

              {sports.toUpperCase() !== "ATHLETICS" &&
                urllink !== "externaltournamentdetails" && (
                  <label htmlFor="tab2" onClick={() => tabclick(2, "Fixtures")}>
                    <span>Fixtures</span>
                  </label>
                )}

              {sports.toUpperCase() === "ATHLETICS" &&
                urllink !== "externaltournamentdetails" && (
                  <label
                    htmlFor="tab2"
                    onClick={() => tabclick(2, "Fixtures and Results")}
                  >
                    <span>Fixtures and Results</span>
                  </label>
                )}
              {sports.toUpperCase() !== "ATHLETICS" &&
                urllink !== "externaltournamentdetails" && (
                  <>
                    <input
                      id="tab3"
                      type="radio"
                      name="tabs"
                      checked={tactive == 3 ? true : false}
                    />
                    <label
                      htmlFor="tab3"
                      onClick={() => tabclick(3, "Leaderboard")}
                    >
                      <span>Leaderboard</span>
                    </label>
                  </>
                )}

              <input
                id="tab4"
                type="radio"
                name="tabs"
                checked={tactive == 4 ? true : false}
              />
              {sports.toUpperCase() !== "ATHLETICS" &&
                urllink !== "externaltournamentdetails" && (
                  <label htmlFor="tab4" onClick={() => tabclick(4, "Teams")}>
                    <span>Teams</span>
                  </label>
                )}
              {sports.toUpperCase() === "ATHLETICS" &&
                urllink !== "externaltournamentdetails" && (
                  <label
                    htmlFor="tab4"
                    onClick={() => tabclick(4, "Leaderboard")}
                  >
                    <span>Leaderboard</span>
                  </label>
                )}

              {sports.toUpperCase() !== "ATHLETICS" &&
                urllink !== "externaltournamentdetails" && (
                  <>
                    <input
                      id="tab5"
                      type="radio"
                      name="tabs"
                      checked={tactive == 5 ? true : false}
                    />
                    <label htmlFor="tab4" onClick={() => tabclick(5, "Pool")}>
                      <span>Pool</span>
                    </label>
                  </>
                )}
              {(photolist.length != 0 || ephotolist != 0 || hlist != 0) && (
                <>
                  <input
                    id="tab6"
                    type="radio"
                    name="tabs"
                    checked={tactive == 6 ? true : false}
                  />
                  <label htmlFor="tab6" onClick={() => tabclick(6, "Gallery")}>
                    <span>Gallery</span>
                  </label>
                </>
              )}
              <section id="content1" className="tab-content">
                <h3>Tournament Info</h3>
                {tdet !== "" && (
                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-striped tourinfo"
                      cellPadding="10px"
                    >
                      <tbody>
                        <tr>
                          <th>Tournament Name</th>
                          <td>{tdet.meet_name}</td>
                        </tr>
                        <tr>
                          <th>Location</th>
                          <td>{tdet.location}</td>
                        </tr>
                        {urllink !== "externaltournamentdetails" && (
                          <tr>
                            <th>Tournament Type</th>
                            <td>{tdet.meet_type}</td>
                          </tr>
                        )}
                        {urllink === "externaltournamentdetails" && (
                          <tr>
                            <th>Tournament Type</th>
                            <td>{tdet.meet_type_name}</td>
                          </tr>
                        )}
                        <tr>
                          <th>Sports Type</th>
                          <td>{tdet.sports_type}</td>
                        </tr>
                        <tr>
                          <th>Start Date</th>
                          <td>
                            {moment(tdet.start_date).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                        <tr>
                          <th>End Date</th>
                          <td>{moment(tdet.end_date).format("DD/MM/YYYY")}</td>
                        </tr>
                        {urllink !== "externaltournamentdetails" && (
                          <>
                            <tr>
                              <th>Entry Opens at</th>
                              <td>
                                {moment(tdet.entry_open).format("DD/MM/YYYY")}
                              </td>
                            </tr>
                            <tr>
                              <th>Entry Last Date</th>
                              <td>
                                {moment(tdet.entry_deadline_date).format(
                                  "DD/MM/YYYY"
                                )}
                              </td>
                            </tr>
                            {tdet.agecat_or_std == 1 && (
                              <tr>
                                <th>Class</th>
                                <td>{tdet.categories}</td>
                              </tr>
                            )}

                            {tdet.agecat_or_std == 2 && (
                              <tr>
                                <th>Age Categories</th>
                                <td>{tdet.categories}</td>
                              </tr>
                            )}
                            <tr>
                              <th>League Format</th>
                              <td>{tdet.league_type}</td>
                            </tr>
                          </>
                        )}

                        {urllink === "externaltournamentdetails" && (
                          <tr>
                            <th>Age Categories</th>
                            <td>{tdet.categories}</td>
                          </tr>
                        )}
                        {/* <tr>
             <th>Fees</th>
             <td className="text-error">
               <b>{tdet.registration_fees} /-</b>
             </td>
           </tr> */}
                      </tbody>
                    </table>
                  </div>
                )}
              </section>

              <section id="content2" className="tab-content">
                {agecat.length == 0 && (
                  <h4 className="text-center text-danger">
                    Fixtures will be updated soon
                  </h4>
                )}
                {agecat.length != 0 && (
                  <>
                    {sports.toUpperCase() !== "ATHLETICS" && (
                      <div className="match_today tcontainer" id="match_today">
                        <Tabs
                          defaultActiveKey={agecatdef}
                          id="uncontrolled-tab-example"
                          className="mb-3"
                          onSelect={subtabclick}
                        >
                          {agecat.map((item, index) => {
                            return (
                              <Tab
                                eventKey={item.id}
                                title={item.category_name}
                                key={index}
                              >
                                <>
                                  {lmatch.length !== 0 && (
                                    <h2>League Matches</h2>
                                  )}
                                  {lmatch.length == 0 && (
                                    <h4 className="text-danger text-center">
                                      Fixtures will be updated soon
                                    </h4>
                                  )}
                                  {lmatch.map((data, i) => {
                                    return (
                                      <div className="widget-content" key={i}>
                                        <div className="mnajiri">
                                          <div className="mnajiriin">
                                            <div className="mpart1">
                                              <div className="right_match">
                                                <span className="right_tech">
                                                  <div className="fname">
                                                    {data.team2_name}
                                                  </div>
                                                </span>
                                              </div>
                                              <strong className="najiri1">
                                                {data.team1_score} :{" "}
                                                {data.team2_score}
                                              </strong>
                                              <div className="left_match">
                                                <span className="left_tech">
                                                  <div className="fname">
                                                    {data.team1_name}
                                                  </div>
                                                </span>
                                              </div>
                                            </div>
                                            <div className="details_match">
                                              <span className="first_match">
                                                <i
                                                  aria-hidden="true"
                                                  className="fas fa-hashtag"
                                                ></i>
                                                <b>Match : {i + 1}</b>
                                              </span>
                                              <span className="thany">
                                                <i
                                                  aria-hidden="true"
                                                  className="fas fa-clock"
                                                ></i>
                                                <b>Time : {data.match_time}</b>
                                              </span>
                                              <span className="liga_mdw">
                                                <i
                                                  aria-hidden="true"
                                                  className="fas fa-calendar-alt"
                                                ></i>
                                                {data.match_date !== null && (
                                                  <b>
                                                    {moment(
                                                      data.match_date
                                                    ).format("DD-MM-YYYY")}
                                                  </b>
                                                )}
                                              </span>
                                            </div>
                                            {data.winner_name !== null && (
                                              <div className="scheduleitems_box_3 text-center">
                                                <h6>{data.winner_name} Won</h6>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                  {qmatch.length !== 0 && (
                                    <>
                                      <h2>Quarter-Finals</h2>

                                      {qmatch.map((data, i) => {
                                        return (
                                          <div
                                            className="widget-content"
                                            key={i}
                                          >
                                            <div className="mnajiri">
                                              <div className="mnajiriin">
                                                <div className="mpart1">
                                                  <div className="right_match">
                                                    <span className="right_tech">
                                                      <div className="fname">
                                                        {data.team2_name}
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <strong className="najiri1">
                                                    {data.team1_score} :{" "}
                                                    {data.team2_score}
                                                  </strong>
                                                  <div className="left_match">
                                                    <span className="left_tech">
                                                      <div className="fname">
                                                        {data.team1_name}
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                                <div className="details_match">
                                                  <span className="first_match">
                                                    <i
                                                      aria-hidden="true"
                                                      className="fas fa-hashtag"
                                                    ></i>
                                                    <b>Match : {i + 1}</b>
                                                  </span>
                                                  <span className="thany">
                                                    <i
                                                      aria-hidden="true"
                                                      className="fas fa-clock"
                                                    ></i>
                                                    <b>
                                                      Time : {data.match_time}
                                                    </b>
                                                  </span>
                                                  <span className="liga_mdw">
                                                    <i
                                                      aria-hidden="true"
                                                      className="fas fa-calendar-alt"
                                                    ></i>
                                                    {data.match_date !==
                                                      null && (
                                                      <b>
                                                        {moment(
                                                          data.match_date
                                                        ).format("DD-MM-YYYY")}
                                                      </b>
                                                    )}
                                                  </span>
                                                </div>
                                                {data.winner_name !== null && (
                                                  <div className="scheduleitems_box_3 text-center">
                                                    <h6>
                                                      {data.winner_name} Won
                                                    </h6>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </>
                                  )}

                                  {smatch.length !== 0 && (
                                    <>
                                      <h2>Semi-Finals</h2>

                                      {smatch.map((data, i) => {
                                        return (
                                          <div
                                            className="widget-content"
                                            key={i}
                                          >
                                            <div className="mnajiri">
                                              <div className="mnajiriin">
                                                <div className="mpart1">
                                                  <div className="right_match">
                                                    <span className="right_tech">
                                                      <div className="fname">
                                                        {data.team2_name}
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <strong className="najiri1">
                                                    {data.team1_score} :{" "}
                                                    {data.team2_score}
                                                  </strong>
                                                  <div className="left_match">
                                                    <span className="left_tech">
                                                      <div className="fname">
                                                        {data.team1_name}
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                                <div className="details_match">
                                                  <span className="first_match">
                                                    <i
                                                      aria-hidden="true"
                                                      className="fas fa-hashtag"
                                                    ></i>
                                                    <b>Match : {i + 1}</b>
                                                  </span>
                                                  <span className="thany">
                                                    <i
                                                      aria-hidden="true"
                                                      className="fas fa-clock"
                                                    ></i>
                                                    <b>
                                                      Time : {data.match_time}
                                                    </b>
                                                  </span>
                                                  <span className="liga_mdw">
                                                    <i
                                                      aria-hidden="true"
                                                      className="fas fa-calendar-alt"
                                                    ></i>
                                                    {data.match_date !==
                                                      null && (
                                                      <b>
                                                        {moment(
                                                          data.match_date
                                                        ).format("DD-MM-YYYY")}
                                                      </b>
                                                    )}
                                                  </span>
                                                </div>
                                                {data.winner_name !== null && (
                                                  <div className="scheduleitems_box_3 text-center">
                                                    <h6>
                                                      {data.winner_name} Won
                                                    </h6>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </>
                                  )}

                                  {fmatch.length !== 0 && (
                                    <>
                                      <h2>Finals</h2>

                                      {fmatch.map((data, i) => {
                                        return (
                                          <div
                                            className="widget-content"
                                            key={i}
                                          >
                                            <div className="mnajiri">
                                              <div className="mnajiriin">
                                                <div className="mpart1">
                                                  <div className="right_match">
                                                    <span className="right_tech">
                                                      <div className="fname">
                                                        {data.team2_name}
                                                      </div>
                                                    </span>
                                                  </div>
                                                  <strong className="najiri1">
                                                    {data.team1_score} :{" "}
                                                    {data.team2_score}
                                                  </strong>
                                                  <div className="left_match">
                                                    <span className="left_tech">
                                                      <div className="fname">
                                                        {data.team1_name}
                                                      </div>
                                                    </span>
                                                  </div>
                                                </div>
                                                <div className="details_match">
                                                  <span className="first_match">
                                                    <i
                                                      aria-hidden="true"
                                                      className="fas fa-hashtag"
                                                    ></i>
                                                    <b>Match : {i + 1}</b>
                                                  </span>
                                                  <span className="thany">
                                                    <i
                                                      aria-hidden="true"
                                                      className="fas fa-clock"
                                                    ></i>
                                                    <b>
                                                      Time : {data.match_time}
                                                    </b>
                                                  </span>
                                                  <span className="liga_mdw">
                                                    <i
                                                      aria-hidden="true"
                                                      className="fas fa-calendar-alt"
                                                    ></i>
                                                    {data.match_date !==
                                                      null && (
                                                      <b>
                                                        {moment(
                                                          data.match_date
                                                        ).format("DD-MM-YYYY")}
                                                      </b>
                                                    )}
                                                  </span>
                                                </div>
                                                {data.winner_name !== null && (
                                                  <div className="scheduleitems_box_3 text-center">
                                                    <h6>
                                                      {data.winner_name} Won
                                                    </h6>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </>
                                  )}
                                </>
                              </Tab>
                            );
                          })}
                        </Tabs>
                      </div>
                    )}
                  </>
                )}

                {sports.toUpperCase() === "ATHLETICS" && (
                  <div
                    className="ag-theme-alpine" // applying the Data Grid theme
                    style={{ height: 550 }} // the Data Grid will fill the size of the parent container
                  >
                    <AgGridReact
                      columnDefs={columnDefs}
                      rowData={rowData}
                      pagination="true"
                      paginationPageSize="10"
                      sortingOrder={["asc", "desc"]}
                      suppressExcelExport={true}
                      suppressDragLeaveHidesColumns={true}
                    />
                  </div>
                )}

                <div
                  style={{ display: sshow ? "block" : "none" }}
                  className={sshow ? "modal fade show" : "modal fade"}
                  id="exampleModal"
                  tabIndex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h6 className="text-danger">
                          {catname}{" "}
                          <span className="text-success">({listtype})</span>
                        </h6>
                      </div>
                      <div
                        className="modal-body"
                        style={{ maxHeight: "60vh", overflowY: "auto" }}
                      >
                        <div
                          className="ag-theme-alpine ag-style mt-2"
                          // style={{ height: "auto" }}
                        >
                          <AgGridReact
                            columnDefs={columnODefs}
                            rowData={filterProduct}
                            pagination="true"
                            paginationPageSize="100"
                            sortingOrder={["asc", "desc"]}
                            suppressExcelExport={true}
                            suppressDragLeaveHidesColumns={true}
                            domLayout="autoHeight"
                          />
                        </div>
                      </div>
                      <div className="modal-footer">
                        <div className="text-right">
                          <a
                            className="btn btn-danger me-2"
                            onClick={handlestoryclose}
                          >
                            Close
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              <section id="content3" className="tab-content">
                {agecat.length == 0 && (
                  <h4 className="text-center text-danger">
                    Leaderboard will be updated soon
                  </h4>
                )}

                {agecat.length != 0 && (
                  <>
                    <h3>Leaderboard</h3>
                    <div className="match_today tcontainer" id="match_today">
                      <Tabs
                        defaultActiveKey={agecatdef}
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        onSelect={ledtabclick}
                      >
                        {agecat.map((item, index) => {
                          return (
                            <Tab
                              eventKey={item.id}
                              title={item.category_name}
                              key={index}
                            >
                              <>
                                {lboard.map((item, i) => {
                                  return (
                                    <>
                                      <div className="text-center" key={i}>
                                        <h5>{item.pool_name}</h5>
                                      </div>
                                      <div className="table-responsive">
                                        <table
                                          className="table table-bordered table-striped pointstable"
                                          cellPadding="10px"
                                        >
                                          <thead>
                                            <tr>
                                              <th>#</th>
                                              <th>Team</th>
                                              <th>Played</th>
                                              <th>Won</th>
                                              <th>Lost</th>
                                              <th>Draw</th>
                                              <th>GF</th>
                                              <th>GA</th>
                                              <th>GD</th>
                                              <th>Points</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item.pool_points.map((data, j) => {
                                              return (
                                                <tr key={j}>
                                                  <td>{j + 1}</td>
                                                  <td>{data.team_name}</td>
                                                  <td>{data.matches_played}</td>
                                                  <td>{data.matches_won}</td>
                                                  <td>{data.matches_lost}</td>
                                                  <td>{data.matches_draw}</td>
                                                  <td>{data.gf}</td>
                                                  <td>{data.ga}</td>
                                                  <td>{data.gd}</td>
                                                  <td>{data.points}</td>
                                                </tr>
                                              );
                                            })}
                                          </tbody>
                                        </table>
                                      </div>
                                    </>
                                  );
                                })}
                              </>
                            </Tab>
                          );
                        })}
                      </Tabs>
                    </div>
                  </>
                )}
              </section>
              {sports.toUpperCase() === "ATHLETICS" && (
                <section id="content4" className="tab-content">
                  {chamlist.length !== 0 && (
                    <>
                      <h4 className="text-center text-danger">
                        OVERALL PERFORMANCE
                      </h4>
                      <div className="table-responsive">
                        <table className="sp-league-table sp-data-table">
                          <thead className="sp-table-header">
                            <tr role="row">
                              <th>Rank</th>
                              <th>School</th>
                              <th>Gold Medals</th>
                              <th>Silver Medals</th>
                              <th>Bronze Medals</th>
                              <th>Total Medals</th>
                              <th>Total Points</th>
                            </tr>
                          </thead>
                          <tbody>
                            {chamlist.map((item, j) => {
                              const getRowColor = () => {
                                return j % 2 === 0 ? "even" : "odd";
                              };
                              return (
                                <>
                                  <tr
                                    className={`sp-row-no-0 ${getRowColor()}`}
                                    key={j}
                                  >
                                    <td className="data-pct">{j + 1}</td>
                                    <td className="data-pct">
                                      {item.school_name}
                                    </td>
                                    <td className="data-pct">
                                      {item.total_gold}
                                    </td>
                                    <td className="data-pct">
                                      {item.total_silver}
                                    </td>
                                    <td className="data-pct">
                                      {item.total_bronze}
                                    </td>
                                    <td className="data-pct">
                                      {parseInt(item.total_gold) +
                                        parseInt(item.total_silver) +
                                        parseInt(item.total_bronze)}
                                    </td>
                                    <td className="data-pct">
                                      {item.total_points}
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <hr />
                    </>
                  )}

                  {agecat.length == 0 && (
                    <h4 className="text-center text-danger">
                      Players will be updated soon
                    </h4>
                  )}

                  {agecat.length != 0 && (
                    <>
                      <Tabs
                        defaultActiveKey={agecatdef}
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        onSelect={playertabclick}
                      >
                        {agecat.map((item, index) => {
                          return (
                            <Tab
                              eventKey={item.id}
                              title={item.category_name}
                              key={index}
                            >
                              <>
                                <h5 className="mb-3 mt-2">Squads</h5>
                                {/* {plist.length === 0 && (
                       <h5 className="mb-3 mt-2 text-danger">No players are added in this category.</h5>
                     )} */}
                                <div className="row">
                                  {plist.map((data1, j) => {
                                    return (
                                      <div className="col-md-4" key={j}>
                                        <div className="card playersslist">
                                          <h5 className="playername">
                                            {data1.first_name}
                                          </h5>
                                          {/* <h4 className="playeruid">
                               {data1.username}
                             </h4> */}
                                          {/* <h5 className="playercate">Category: {data1.tournament_category}</h5> */}
                                          <h5 className="playerevent">
                                            Gold : {data1.total_gold}
                                          </h5>
                                          <h5 className="playerevent">
                                            Silver : {data1.total_silver}
                                          </h5>
                                          <h5 className="playerevent">
                                            Bronze : {data1.total_bronze}
                                          </h5>
                                          <h5 className="playercate">
                                            Total Points : {data1.total_points}
                                          </h5>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </>
                            </Tab>
                          );
                        })}
                      </Tabs>
                    </>
                  )}

                  {/* <Tabs
       defaultActiveKey={agecatdef}
       id="uncontrolled-tab-example"
       className="mb-3"
       onSelect={playertabclick}
     >
       {agecat.map((item, index) => {
         return (
           <Tab
             eventKey={item.id}
             title={item.category_name}
             key={index}
           >
             <>
             <h5 className="mb-3 mt-2">Squads</h5>
                 <div className="row">
                     {plist.map((data1, j) => {
                       return (
                         <div className="col-md-4" key={j}>
                           <div className="card playersslist">
                             <h5 className="playername">{data1.first_name}</h5>
                             <h4 className="playeruid">{data1.username}</h4>
                             <h5 className="playercate">Category: {data1.tournament_category}</h5>
                             <h5 className="playerevent">Event: {data1.eventslist}</h5>


                           </div>
                         </div>
                       );
                     })

                     }
                  
                 </div>
  
             </>
           </Tab>
         );
       })}
     </Tabs> */}
                </section>
              )}

              {sports.toUpperCase() !== "ATHLETICS" && (
                <section id="content4" className="tab-content">
                  {agecat.length == 0 && (
                    <h4 className="text-center text-danger">
                      Teams will be updated soon
                    </h4>
                  )}

                  {agecat.length != 0 && (
                    <>
                      <h3>Teams</h3>

                      <Tabs
                        defaultActiveKey={agecatdef}
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        onSelect={teamtabclick}
                      >
                        {agecat.map((item, index) => {
                          return (
                            <Tab
                              eventKey={item.id}
                              title={item.category_name}
                              key={index}
                            >
                              <>
                                <Accordion onSelect={playertabclick}>
                                  {tlist.map((data, i) => {
                                    return (
                                      <Accordion.Item
                                        eventKey={data.id}
                                        key={i}
                                      >
                                        <Accordion.Header>
                                          {data.team_name}
                                        </Accordion.Header>
                                        <Accordion.Body>
                                          <h5 className="mb-3 mt-2">Squads</h5>
                                          <div className="row">
                                            {plist.map((data1, j) => {
                                              return (
                                                <div
                                                  className="col-md-4"
                                                  key={j}
                                                >
                                                  <div className="card playersslist">
                                                    <h5 className="playername">
                                                      {data1.first_name}
                                                    </h5>
                                                    {/* <h4 className="playeruid">
                                         {data1.username}
                                       </h4> */}
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </div>
                                        </Accordion.Body>
                                      </Accordion.Item>
                                    );
                                  })}
                                </Accordion>
                              </>
                            </Tab>
                          );
                        })}
                      </Tabs>
                    </>
                  )}
                </section>
              )}

              {sports.toUpperCase() !== "ATHLETICS" && (
                <section id="content5" className="tab-content">
                  {agecat.length == 0 && (
                    <h4 className="text-center text-danger">
                      Pool will be updated soon
                    </h4>
                  )}

                  {agecat.length != 0 && (
                    <>
                      <h3>Pool</h3>

                      <Tabs
                        defaultActiveKey={agecatdef}
                        id="uncontrolled-tab-example"
                        className="mb-3"
                        onSelect={pooltabclick}
                      >
                        {agecat.map((item, index) => {
                          return (
                            <Tab
                              eventKey={item.id}
                              title={item.category_name}
                              key={index}
                            >
                              <div className="row">
                                {poollist.map((data1, j) => {
                                  return (
                                    <div className="col-md-4" key={j}>
                                      <h5 className="mb-3 mt-2">
                                        {data1.pool_name}
                                      </h5>
                                      <div className="card playersslist">
                                        {data1.teamlist.map((data, i) => {
                                          return (
                                            <h5 className="playername" key={i}>
                                              {data.teams_name}
                                            </h5>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </Tab>
                          );
                        })}
                      </Tabs>
                    </>
                  )}
                </section>
              )}

              <section id="content6" className="tab-content">
                <h3>Gallery</h3>
                <div className="row">
                  {hlist.map((data, i) => {
                    return (
                      <div className="col-md-2 mt-4" key={i}>
                        <a href={data.highlight_links} target="_blank">
                          <img
                            className="photoimg"
                            title={data.highlight_links}
                            src={require("../assets/img/video.png")}
                            height="100px"
                            alt="Photo"
                          />
                        </a>
                      </div>
                    );
                  })}
                  {photolist.map((data, i) => {
                    return (
                      <div
                        className="col-md-2 mt-4"
                        key={i}
                        style={{ position: "relative" }}
                      >
                        <a
                          className="photo-share"
                          onClick={() => handleshow(data.src)}
                        >
                          <i
                            className="fas fa-share fa-lg"
                            style={{ color: "#fff" }}
                          ></i>
                        </a>
                        <img
                          className="photoimg"
                          src={data.src}
                          height="100px"
                          onClick={() => openPLightbox(i, photolist)}
                          alt="Photo"
                        />
                      </div>
                    );
                  })}
                  {ephotolist.map((data, i) => {
                    return (
                      <div
                        className="col-md-2 mt-4"
                        key={i}
                        style={{ position: "relative" }}
                      >
                        <a
                          className="photo-share"
                          onClick={() => handleshow(data.src)}
                        >
                          <i
                            className="fas fa-share fa-lg"
                            style={{ color: "#fff" }}
                          ></i>
                        </a>
                        <img
                          className="photoimg"
                          src={data.src}
                          height="100px"
                          onClick={() => openPLightbox(i, ephotolist)}
                          alt="Photo"
                        />
                      </div>
                    );
                  })}
                </div>
              </section>
              <div className={show ? "mymodal open" : "mymodal"}>
                <div className="modoverlay"></div>
                <div className="mymodal-content">
                  <h4 className="text-center">Share Photos</h4>
                  <span className="close-btn" onClick={handleclose}>
                    &times;
                  </span>
                  <div className="border-bottom"></div>
                  <Row className="row-sm mt-3">
                    <div className="text-center">
                      <WhatsappShareButton
                        url={shareUrl}
                        title="Hey, check out my photos!"
                        className="me-3"
                      >
                        <WhatsappIcon size={44} round={true} />
                      </WhatsappShareButton>
                      <FacebookShareButton
                        url={shareUrl}
                        quote="Hey, check out my photos!"
                        className="me-3"
                      >
                        <FacebookIcon size={44}></FacebookIcon>
                      </FacebookShareButton>
                      <TwitterShareButton
                        url={shareUrl}
                        title="Hey, check out my photos!"
                        className="me-3"
                      >
                        <TwitterIcon size={44}></TwitterIcon>
                      </TwitterShareButton>
                    </div>
                  </Row>
                  {/* <a className="btn btn-gray" onClick={handleclose}>Close </a> */}
                </div>
              </div>
              <ModalGateway>
                {viewerIsOpen ? (
                  <Modal onClose={closeLightbox}>
                    <Carousel
                      currentIndex={currentImage}
                      views={pplist.map((x) => ({
                        ...x,
                        srcset: x.srcSet,
                        caption: x.title,
                      }))}
                    />
                  </Modal>
                ) : null}
              </ModalGateway>
            </div>
          )}

          {(urllink == "fundereventdetails" || urllink == "eventdetails") && (
            <div className="tab_container">
              <input
                id="tab1"
                type="radio"
                name="tabs"
                checked={tactive == 1 ? true : false}
              />
              <label htmlFor="tab1" onClick={() => etabclick(1, "Event Info")}>
                <span>Event Info</span>
              </label>
              {plist.length != 0 && (
                <>
                  <input
                    id="tab2"
                    type="radio"
                    name="tabs"
                    checked={tactive == 2 ? true : false}
                  />
                  <label htmlFor="tab2" onClick={() => etabclick(2, "Players")}>
                    <span>Players</span>
                  </label>
                </>
              )}
              {ephotolist.length != 0 && (
                <>
                  <input
                    id="tab3"
                    type="radio"
                    name="tabs"
                    checked={tactive == 3 ? true : false}
                  />
                  <label htmlFor="tab3" onClick={() => etabclick(3, "Gallery")}>
                    <span>Gallery</span>
                  </label>
                </>
              )}
              <section id="content1" className="tab-content">
                <h3>Event Info</h3>
                {tdet !== "" && (
                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-striped tourinfo"
                      cellPadding="10px"
                    >
                      <tbody>
                        <tr>
                          <th>Event Name</th>
                          <td>{tdet.event_name}</td>
                        </tr>
                        <tr>
                          <th>Event Type</th>
                          <td>{tdet.entryeventname}</td>
                        </tr>
                        <tr>
                          <th>Start Date</th>
                          <td>
                            {moment(tdet.start_date).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                        <tr>
                          <th>End Date</th>
                          <td>{moment(tdet.end_date).format("DD/MM/YYYY")}</td>
                        </tr>
                        <tr>
                          <th>Entry Opens at</th>
                          <td>
                            {moment(tdet.entry_start_date).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                        <tr>
                          <th>Entry Last Date</th>
                          <td>
                            {moment(tdet.entry_end_date).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                        <tr>
                          <th>Age Category</th>
                          <td>{tdet.event_age_category}</td>
                        </tr>
                        <tr>
                          <th>Registration Type</th>
                          <td style={{ textTransform: "capitalize" }}>
                            {tdet.internalorexternal}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </section>
              <section id="content2" className="tab-content">
                {plist.length == 0 && (
                  <h4 className="text-center text-danger">
                    Players will be updated soon
                  </h4>
                )}

                {plist.length != 0 && (
                  <>
                    <h5 className="mb-3 mt-2">Squads</h5>
                    <div className="row">
                      {plist.map((data1, j) => {
                        return (
                          <div className="col-md-4" key={j}>
                            <div className="card playersslist">
                              <h5 className="playername">{data1.first_name}</h5>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </section>

              <section id="content3" className="tab-content">
                <h3>Gallery</h3>
                <div className="row">
                  {ephotolist.map((data, i) => {
                    return (
                      <div
                        className="col-md-2 mt-4"
                        key={i}
                        style={{ position: "relative" }}
                      >
                        <a
                          className="photo-share"
                          onClick={() => handleshow(data.src)}
                        >
                          <i
                            className="fas fa-share fa-lg"
                            style={{ color: "#fff" }}
                          ></i>
                        </a>
                        <img
                          className="photoimg"
                          src={data.src}
                          height="100px"
                          onClick={() => openPLightbox(i, ephotolist)}
                          alt="Photo"
                        />
                      </div>
                    );
                  })}
                </div>
              </section>

              <div className={show ? "mymodal open" : "mymodal"}>
                <div className="modoverlay"></div>
                <div className="mymodal-content">
                  <h4 className="text-center">Share Photos</h4>
                  <span className="close-btn" onClick={handleclose}>
                    &times;
                  </span>
                  <div className="border-bottom"></div>
                  <Row className="row-sm mt-3">
                    <div className="text-center">
                      <WhatsappShareButton
                        url={shareUrl}
                        title="Hey, check out my photos!"
                        className="me-3"
                      >
                        <WhatsappIcon size={44} round={true} />
                      </WhatsappShareButton>
                      <FacebookShareButton
                        url={shareUrl}
                        quote="Hey, check out my photos!"
                        className="me-3"
                      >
                        <FacebookIcon size={44}></FacebookIcon>
                      </FacebookShareButton>
                      <TwitterShareButton
                        url={shareUrl}
                        title="Hey, check out my photos!"
                        className="me-3"
                      >
                        <TwitterIcon size={44}></TwitterIcon>
                      </TwitterShareButton>
                    </div>
                  </Row>
                  {/* <a className="btn btn-gray" onClick={handleclose}>Close </a> */}
                </div>
              </div>

              <ModalGateway>
                {viewerIsOpen ? (
                  <Modal onClose={closeLightbox}>
                    <Carousel
                      currentIndex={currentImage}
                      views={pplist.map((x) => ({
                        ...x,
                        srcset: x.srcSet,
                        caption: x.title,
                      }))}
                    />
                  </Modal>
                ) : null}
              </ModalGateway>
            </div>
          )}
        </div>
      </section>

      {/* <footer className="footer-layout1 footer-wrapper bg-title space-top">
        <div className="widget-area">
          <div className="tcontainer">
            <div className="row gx-5">
              <div className="col-md-6 col-xl-5">
                <div className="widget footer-widget">
                  <img
                    src={require("../assets/images/Muthoot-Finance.png")}
                    alt="footer"
                  />
                  <p className="footer-text text-white">
                    Founded in 1962 & managed by St. George’s Education Society,
                    a charitable non-profit Society chaired by Shri M. G. George
                    Muthoot, Chairman – The Muthoot Group.
                  </p>
                </div>
              </div>
              <div className="col-md-6 col-xl-3"></div>
              <div className="col-md-6 col-xl-4">
                <div className="contact-style1">
                  <h4 className="contact-title mb-0">Contact Details</h4>
                  <p className="contact-text">
                    Contact to get every single updates
                  </p>
                  <div className="vs-widget-about">
                    <p className="footer-address">
                      <a className="text-inherit">
                        <i className="fa fa-map-marker-alt"></i>
                        <span>
                          Knbcomplex, Kareyanapalaya, Lingarajapuram, Bangalore
                          - 560084{" "}
                        </span>
                      </a>
                    </p>
                    <p className="footer-address">
                      <a
                        className="text-inherit"
                        href="mailto:info@example.com"
                      >
                        <i className="far fa-envelope"></i>
                        <span>mails@muthootgroup.com </span>
                      </a>
                    </p>
                    <p className="footer-address">
                      <a className="text-inherit" href="tel:++11234562228">
                        <i className="fa fa-phone-alt"></i>
                        <span>098958 89293</span>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="tcontainer">
            <div className="copyright-area">
              <div className="row justify-content-between align-items-center">
                <div className="text-center col-lg-auto">
                  <p className="copyright-text text-white">
                    <i className="fa fa-copyright"></i> Copyright 2024 -{" "}
                    <a
                      href="https://pathwayz.sportzvillage.com/"
                      className="text-secondary"
                      target="_blank"
                    >
                      Sportz Village
                    </a>
                  </p>
                </div>
                <div className="terms-condition  col-lg-auto">
                  <p className="copyright-text text-white">
                    Developed by{" "}
                    <a
                      href="https://sportingindia.tech"
                      className="text-error"
                      target="_blank"
                    >
                      Sportingindia
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer> */}
      <footer className="footer-layout1 footer-wrapper bg-title space-top">
        <div className="widget-area">
          <div className="container">
            <div className="row gx-5">
              <div className="col-md-6 col-xl-5">
                <div className="widget footer-widget">
                  <img
                    src={logofile}
                    alt="footer"
                    onError={(e) => errorhandle(e)}
                  />
                  <p className="footer-text text-white">{funddesc}</p>
                </div>
              </div>
              <div className="col-md-6 col-xl-3"></div>
              <div className="col-md-6 col-xl-4">
                <div className="contact-style1">
                  <h4 className="contact-title mb-0">Contact Details</h4>
                  <p className="contact-text">
                    Contact to get every single updates
                  </p>
                  <div className="vs-widget-about">
                    {fundaddr !== "" && (
                      <p className="footer-address">
                        <a className="text-inherit">
                          <i className="far fa-map-marker-alt"></i>
                          <span>{fundaddr}</span>
                        </a>
                      </p>
                    )}

                    {fundmail !== "" && (
                      <p className="footer-address">
                        <a className="text-inherit">
                          <i className="far fa-envelope"></i>
                          <span>{fundmail}</span>
                        </a>
                      </p>
                    )}

                    {fundmob !== "" && (
                      <p className="footer-address">
                        <a className="text-inherit">
                          <i className="far fa-phone-alt"></i>
                          <span>{fundmob}</span>
                        </a>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="container">
            <div className="copyright-area">
              <div className="row justify-content-between align-items-center">
                <div className="text-center col-lg-auto">
                  <p className="copyright-text text-white">
                    <i className="fal fa-copyright"></i> Copyright 2024 -{" "}
                    <a
                      href="https://pathwayz.sportzvillage.com/"
                      className="text-secondary"
                      target="_blank"
                    >
                      Sportz Village
                    </a>
                  </p>
                </div>
                <div className="terms-condition  col-lg-auto">
                  <p className="copyright-text text-white">
                    Developed by{" "}
                    <a
                      href="https://sportingindia.tech"
                      className="text-error"
                      target="_blank"
                    >
                      Sportingindia
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <a className="scrollToTop scroll-btn">
        <i className="far fa-arrow-up"></i>
      </a>
    </>
  );
};
